// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAjYLjPABGYEWW51_b5SSqXWItlpbDDuvI",
  authDomain: "updateemailmarketingtoolsdemo.firebaseapp.com",
  projectId: "updateemailmarketingtoolsdemo",
  storageBucket: "updateemailmarketingtoolsdemo.firebasestorage.app",
  messagingSenderId: "417351558400",
  appId: "1:417351558400:web:a92efaecd53992f2fdffe5"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;
